module.exports = __webpack_public_path__ + "static/media/SellerboxFuncIconRobot.e3c53633.png";